"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.FeaturedWeekPill = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _index = require("../index");
var FeaturedWeekPill = exports.FeaturedWeekPill = function FeaturedWeekPill(_ref) {
  var weekId = _ref.weekId,
    isWeekPill = _ref.isWeekPill;
  var isFeatured = Object.keys(_index.FEATURED_WEEKS).includes(String(weekId));
  if (!isFeatured) {
    return null;
  }
  var pillData = _index.FEATURED_WEEKS[weekId][isWeekPill ? 'weekPill' : 'featuredPill'];
  if (!pillData) {
    return null;
  }
  var tooltipContent = function tooltipContent(link) {
    return /*#__PURE__*/_react["default"].createElement("span", null, "Click ", /*#__PURE__*/_react["default"].createElement(_index.Link, {
      href: link,
      external: true
    }, "here"), " to find out more");
  };
  return /*#__PURE__*/_react["default"].createElement(_index.Tooltip, {
    title: pillData.tooltip,
    content: tooltipContent(pillData.link),
    interactive: true
  }, /*#__PURE__*/_react["default"].createElement(_index.Pill, {
    type: pillData.type || null,
    title: pillData.title,
    icon: pillData.icon,
    iconcolor: pillData.iconColor,
    iconFlip: true,
    size: _index.PILL_SIZES.SMALL
  }));
};
FeaturedWeekPill.propTypes = {
  weekId: _propTypes["default"].number.isRequired
};
var _default = exports["default"] = FeaturedWeekPill;